export default class GlossaryNav extends HTMLElement {
  constructor() {
    super();
    this.nav = this.querySelector('.glossary-categories-nav');
    this.navLinks = this.querySelectorAll('.glossary-categories-nav a');
    this.items = document.querySelectorAll('.glossary-item');
  }

  connectedCallback() {
    this.navLinks.forEach(navLink => {
      const target = document.querySelector(`.glossary-item[data-category="${navLink.dataset.category}"]`)
      if (target) {
        navLink.addEventListener('click', (event) => {
          event.preventDefault();
          target.scrollIntoView({
            behavior: "smooth",
          });
        });
      }
    });
  }

  disconnectedCallback() {
  }
}

// Define the new web component
if ('customElements' in window) {
  customElements.define('glossary-nav', GlossaryNav);
}
